import AppConfig from 'config/AppConfig';
import ApiService from 'services/ApiService';
import { LOCATION_CHANGE } from 'react-router-redux';
import { put, take, takeLatest, call, all, select, fork, takeEvery } from 'redux-saga/effects';
import { delay, eventChannel } from 'redux-saga';
import { AppActionTypes, AppActions } from './actions';
import { AppSelectors } from './selectors';

import Constants from './constants';
import { TrackingSelectors } from '../trackingModule/selectors';
import { UserSelectors } from '../userModule/selectors';
import AnalyticsCore from '../../components/AnalyticsHandler/AnalyticsCore';
import AnalyticsEventNames from '../../components/AnalyticsHandler/AnalyticsEventNames';
import { NotificationActions } from '../notificationModule/actions';
import { MESSAGES } from '../../constants/Constants';

const KEEP_ALIVE_INTERVAL_MS = 30000;

function* onStartup() {
  // const response = yield call(ApiService.getCurrentUser);

  // yield put(UserActions.currentUser.success(response.data));
  yield put(AppActions.startUpCompleted());
}

function* onPerformPrintRequest() {
  // console.log('delay print request');
  yield delay(3000);
  yield put(AppActions.performPrintSuccess());
  yield call([window, window.print]);
}

function* printWatcher() {
  /* Handle print mode dialog close */
  const printChannel = eventChannel(emitter => {
    function afterPrint() {
      emitter('after');
    }

    function beforePrint() {
      emitter('before');
    }

    window.addEventListener('afterprint', afterPrint);
    window.addEventListener('beforeprint', beforePrint);
    return () => {
      window.removeEventListener('beforeprint', beforePrint);
      window.removeEventListener('afterprint', afterPrint);
    };
  });

  while (true) {
    const printEvent = yield take(printChannel);

    if (printEvent === 'before') {
      const printState = yield select(AppSelectors.printModeSelector);
      if (printState === Constants.PRINT_MODE_NONE) {
        yield put(AppActions.selectPrintOption(Constants.PRINT_MODE_DIRECT));
        yield put(AppActions.performPrintRequest());
      }
      continue;
    }

    yield put(AppActions.closePrintModal());
  }
}

function* onURLLocationChange(action) {
  const { location } = action.payload;

  $('#lang-form').attr(
    'action',
    `${AppConfig.CHANGE_LANGUAGE_PATH}?next=${location.pathname}${encodeURIComponent(location.search)}`,
  );
}

function* eventHandler(action) {
  const data = action.payload;
  try {
    yield call(ApiService.sendAnalyticsEvent, data);
  } catch (e) {
    console.error('e', e);
  }
}

function* onSwitchVersion() {
  try {
    const tracking = yield select(TrackingSelectors.stateSelector);
    const user = yield select(UserSelectors.stateSelector);
    const trackingEvent = AnalyticsCore.buildEvent({
      user,
      tracking,
      eventName: AnalyticsEventNames.SWITCH_TO_OLD_VERSION,
    });
    AnalyticsCore.sendGAEvent(trackingEvent);
    const sendEvent = yield call(ApiService.sendAnalyticsEvent, trackingEvent);
    const resp = yield call(ApiService.switchOffNewVersion);
    const url = `${resp.data.redirect}${window.location.pathname}${window.location.search}`;

    window.location.href = url;
  } catch (e) {
    console.log(e);
  }
}

function* onOrganizationSettingsFailed() {
  yield put(NotificationActions.addNotification(MESSAGES.ORGANIZATION_SETTINGS_FAILED_UPDATE, 'error'));
}

export default function* watch() {
  yield all([
    takeEvery(AppActionTypes.SEND_EVENT, eventHandler),
    fork(printWatcher),
    takeLatest(LOCATION_CHANGE, onURLLocationChange),
    takeLatest(AppActionTypes.DISABLE_NEW_VERSION, onSwitchVersion),
    takeLatest(AppActionTypes.STARTUP, onStartup),
    takeLatest(AppActionTypes.PERFORM_PRINT_REQUEST, onPerformPrintRequest),
    takeLatest(AppActionTypes.UPDATE_ORGANIZATION_SETTINGS_FAILED, onOrganizationSettingsFailed),
  ]);
}
